import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { commerce } from '../../../lib/commerce'
import CssBaseline from '@mui/material/CssBaseline'
import Paper from '@mui/material/Paper'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import Button from '@mui/material/Button'
import AddressForm from '../AddressForm'
import PaymentForm from '../PaymentForm'

import './checkout.css'

const steps = ['Shipping address', 'Payment details']

const Checkout = ({ cart, onCaptureCheckout, order, error }) => {

  const [ checkoutToken, setCheckoutToken] = useState(null)
  const [ activeStep,    setActiveStep   ] = useState(0)
  const [ shippingData,  setShippingData ] = useState({})
  const [ isFinished,    setIsFinished   ] = useState(false)
  const navigate = useNavigate()

  const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)
  const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1)

  useEffect(() => {
    if (cart.id) {
      const generateToken = async () => {
        try {
          const token = await commerce.checkout.generateToken(cart.id, { type: 'cart' })
          setCheckoutToken(token)
        } catch (error) {
          console.log(error)
          if (activeStep !== steps.length) navigate('/')
        }
      }
      generateToken()
    }
  }, [ cart ])

  const next = (data) => {
    setShippingData(data)
    nextStep()
  }

  const timeout = () => {
    setTimeout(() => {
      setIsFinished(true)
    }, 3000)
  }

  let Confirmation = () => order.customer ? (    
    <>
      <div>
        <Typography variant="h5">Thank you for your purchase, {order.customer.firstname} {order.customer.lastname}!</Typography>
        <Divider className="divider" />
        <Typography variant="subtitle2">Order ref: {order.customer_reference}</Typography>
      </div>
      <br />
      <Button component={Link} variant="outlined" type="button" to="/">Back to Home</Button>
    </>
  ) : isFinished ? (
    <>
      <div>
        <Typography variant="h5">Thank you for your purchase!</Typography>
        <Divider className="divider" />
      </div>
      <br />
      <Button component={Link} variant="outlined" type="button" to="/">Back to Home</Button>
    </>
  ) : (
      <div className="spinner">
        <CircularProgress />
      </div>
  )    

  if (error) {
    Confirmation = () => (
      <>
        <Typography variant="h5">Error: {error}</Typography>
        <br />
        <Button component={Link} variant="outlined" type="button" to="/">Back to Home</Button>
      </>
    )
  }

  const Form = () => (activeStep === 0
    ? <AddressForm checkoutToken={checkoutToken} nextStep={nextStep} setShippingData={setShippingData} next={next} />
    : <PaymentForm checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} shippingData={shippingData} onCaptureCheckout={onCaptureCheckout} timeout={timeout} />)

  return (
    <>
      <CssBaseline />
      <div className="toolbar" />

      <main className="layout">

        <Paper className="paper">

          <Typography variant="h4" align="center">Checkout</Typography>
          
          <Stepper activeStep={activeStep} className="stepper">
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep === steps.length ? <Confirmation /> : checkoutToken && <Form />}
        </Paper>
      </main>
    </>
  )
}

export default Checkout